<div class="procedure-details-wrapper">
  @if (!details()) {
    <div class="loading">
      <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych usługi..." />
    </div>
  } @else {
    @let ms = details()!;

    <div class="med-service-view">
      <!-- HERO -->
      <nz-card class="profile-card" [nzBordered]="false">
        <div class="profile-header">
          <div class="profile-icon">
            <span nz-icon nzType="medicine-box" nzTheme="outline"></span>
          </div>

          <div class="profile-info">
            <h1 class="profile-name">
              {{ ms.name || '-' }}
            </h1>

            <div class="profile-meta">
              @if (ms.type) {
                <nz-tag nzColor="blue">
                  <span nz-icon nzType="tag"></span>
                  {{ ms.type }}
                </nz-tag>
              }

              @if (ms.code) {
                <span class="badge">
                  <span nz-icon nzType="idcard"></span>
                  {{ ms.code }}
                </span>
              }

              @if (ms.icd9Code) {
                <span class="badge">
                  <span nz-icon nzType="file-text"></span>
                  ICD-9: {{ ms.icd9Code }}
                </span>
              }
            </div>
          </div>
        </div>
      </nz-card>

      <!-- DETAILS GRID -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="profile" nzTheme="outline" class="section-icon"></span>
          <span>Dane usługi</span>
        </div>

        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Kod</span>
            <span class="detail-value">
              {{ ms.code || '-' }}
            </span>
          </div>

          <div class="detail-item">
            <span class="detail-label">ICD-9</span>
            <span class="detail-value">
              {{ ms.icd9Code || '-' }}
            </span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Typ</span>
            <span class="detail-value">
              {{ getModalityName(ms.type!) || '-' }}
            </span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Obszar ciała</span>
            <span class="detail-value">
              {{ ms.bodyAreaCode || '-' }}
            </span>
            <span class="detail-value">
              {{ getBodyAreaName(ms.bodyAreaCode!) || '-' }}
            </span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Punkty NFZ</span>
            <span class="detail-value">
              {{ ms.nhfPoints || '-' }}
            </span>
          </div>

          <div class="detail-item">
            <span class="detail-label">Domyślny czas wykonania</span>
            <span class="detail-value">
              {{ ms.defaultEtcInMinutes || '-' }}
              @if (ms.defaultEtcInMinutes) {
                <span>min</span>
              }
            </span>
          </div>
        </div>
      </nz-card>

      <!-- OPTIONS GRID -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="setting" nzTheme="outline" class="section-icon"></span>
          <span>Parametry</span>
        </div>

        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Z kontrastem</span>
            @if (getBooleanValue(ms.withContrast) === true) {
              <nz-icon nzType="check" />
            } @else if (getBooleanValue(ms.withContrast) === false) {
              <nz-icon nzType="close" />
            } @else {
              -
            }
          </div>

          <div class="detail-item">
            <span class="detail-label">Ze strony kręgosłupa</span>
            @if (getBooleanValue(ms.withSpine) === true) {
              <nz-icon nzType="check" />
            } @else if (getBooleanValue(ms.withSpine) === false) {
              <nz-icon nzType="close" />
            } @else {
              -
            }
          </div>

          <div class="detail-item">
            <span class="detail-label">Przed / po kontraście</span>
            @if (getBooleanValue(ms.withPrePostContrast) === true) {
              <nz-icon nzType="check" />
            } @else if (getBooleanValue(ms.withPrePostContrast) === false) {
              <nz-icon nzType="close" />
            } @else {
              -
            }
          </div>
        </div>
      </nz-card>
    </div>

    <div class="button-footer-wrapper">
      <a nz-button nzType="default" routerLink="/procedures">
        <span nz-icon nzType="arrow-left"></span>
        Wstecz
      </a>
    </div>
  }
</div>
